import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Checkmark } from '../../primitives/Checkbox/components/Checkmark/index.js';
import { Container } from '../../primitives/Checkbox/components/Container.js';
import { Label } from '../../primitives/internal/Label/index.js';
import { Message } from '../../primitives/internal/Message/index.js';
import { LabelXSmall } from '../../primitives/Typography/LabelXSmall.js';
export const Checkbox = /*#__PURE__*/_styled(forwardRef(({
  label,
  subLabel,
  checked = false,
  disabled = false,
  invalid,
  size = 'medium',
  onChange,
  message,
  className,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ref: ref,
    className: className,
    disabled: disabled,
    size: size,
    children: [_jsx(Checkmark, {
      ...restProps,
      invalid: invalid,
      checked: checked,
      disabled: disabled,
      size: size,
      onChange: onChange
    }), label && _jsxs(Label, {
      size: size,
      checked: checked,
      disabled: disabled,
      ...(typeof label === 'string' ? {
        'data-label': label
      } : null),
      children: [label, subLabel && _jsx(LabelXSmall, {
        color: "contentSecondary",
        lineHeight: "normal",
        children: subLabel
      })]
    }), message && _jsx(Message, {
      invalid: invalid,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1k3m8kb0"
} : {
  target: "e1k3m8kb0",
  label: "Checkbox"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVJIiwiZmlsZSI6IkNoZWNrYm94LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDaGVja21hcmsgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0NoZWNrYm94L2NvbXBvbmVudHMvQ2hlY2ttYXJrL2luZGV4LmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQ2hlY2tib3gvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgTGFiZWwgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL2ludGVybmFsL0xhYmVsL2luZGV4LmpzJztcbmltcG9ydCB7IE1lc3NhZ2UgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL2ludGVybmFsL01lc3NhZ2UvaW5kZXguanMnO1xuaW1wb3J0IHsgTGFiZWxYU21hbGwgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1R5cG9ncmFwaHkvTGFiZWxYU21hbGwuanMnO1xuZXhwb3J0IGNvbnN0IENoZWNrYm94ID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgbGFiZWwsIHN1YkxhYmVsLCBjaGVja2VkID0gZmFsc2UsIGRpc2FibGVkID0gZmFsc2UsIGludmFsaWQsIHNpemUgPSAnbWVkaXVtJywgb25DaGFuZ2UsIG1lc3NhZ2UsIGNsYXNzTmFtZSwgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoQ29udGFpbmVyLCB7IHJlZjogcmVmLCBjbGFzc05hbWU6IGNsYXNzTmFtZSwgZGlzYWJsZWQ6IGRpc2FibGVkLCBzaXplOiBzaXplLCBjaGlsZHJlbjogW19qc3goQ2hlY2ttYXJrLCB7IC4uLnJlc3RQcm9wcywgaW52YWxpZDogaW52YWxpZCwgY2hlY2tlZDogY2hlY2tlZCwgZGlzYWJsZWQ6IGRpc2FibGVkLCBzaXplOiBzaXplLCBvbkNoYW5nZTogb25DaGFuZ2UgfSksIGxhYmVsICYmIChfanN4cyhMYWJlbCwgeyBzaXplOiBzaXplLCBjaGVja2VkOiBjaGVja2VkLCBkaXNhYmxlZDogZGlzYWJsZWQsIC4uLih0eXBlb2YgbGFiZWwgPT09ICdzdHJpbmcnID8geyAnZGF0YS1sYWJlbCc6IGxhYmVsIH0gOiBudWxsKSwgY2hpbGRyZW46IFtsYWJlbCwgc3ViTGFiZWwgJiYgKF9qc3goTGFiZWxYU21hbGwsIHsgY29sb3I6IFwiY29udGVudFNlY29uZGFyeVwiLCBsaW5lSGVpZ2h0OiBcIm5vcm1hbFwiLCBjaGlsZHJlbjogc3ViTGFiZWwgfSkpXSB9KSksIG1lc3NhZ2UgJiYgX2pzeChNZXNzYWdlLCB7IGludmFsaWQ6IGludmFsaWQsIGNoaWxkcmVuOiBtZXNzYWdlIH0pXSB9KSk7XG59KSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGVja2JveC5qcy5tYXAiXX0= */");